import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { SearchIcon } from 'assets/icons'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'
import IconMessageButton from '~/components/MainMenu/IconMessageButton'
import NavVertical from '~/components/MainMenu/NavVertical'
import Logo from '~/components/MainMenu/Logo'
import MainMenuMobile from '~/components/MainMenu/Mobile'
import UserAccountControl from '~/components/MainMenu/UserAccountControl'
import ToolsBlock from '~/components/MainMenu/ToolsBlock'

const BoxLayout = ({ children }) => {
   const { protoTheme: theme } = useContext(ProtoThemeContext)

   return (
      <>
         <MainMenuMobile />
         <View
            display="none[a-c] flex[d-f]"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            height={theme.tmpHeaderHeight}
            backgroundColor={theme.tmpMainMenuBackgroundColor}
            borderBottom={`1px solid ${theme.tmpMainMenuBorderColor}`}
            paddingHorizontal={theme.tmpViewportPadding}>
            <View flex="0 0 auto" width="210px[a-d] 250px[e-f]">
               <Logo />
            </View>
            <View flex="1 1 auto">
               <View
                  display="flex"
                  alignItems="center"
                  height="40px"
                  padding="0px 15px"
                  borderRadius={theme.tmpBorderRadius}
                  backgroundColor={theme.tmpMainMenuSearchBackgroundColor}>
                  <View width="20px" marginTop="2px" marginRight="10px" opacity="0.5">
                     <SearchIcon
                        width="15px"
                        height="15px"
                        strokeWidth="5px"
                        color={theme.tmpMainMenuTextColor}
                     />
                  </View>
                  <Text color={theme.tmpMainMenuTextColor} size="2.5" style={{ opacity: 0.6 }}>
                     Search
                  </Text>
               </View>
            </View>
            <View
               flex="0 0 auto"
               width="210px[a-d] 250px[e-f]"
               display="flex"
               justifyContent="flex-end"
               alignItems="center">
               <IconMessageButton color={theme.tmpMainMenuTextColor} size="18px" />
               <View
                  display="none[a-c] flex[d-f]"
                  justifyContent="center"
                  alignItems="center"
                  flex="0 0 auto"
                  marginLeft="5px"
                  width="40px"
                  height="40px">
                  <View
                     width="1px"
                     height="24px"
                     backgroundColor={theme.tmpMainMenuTextColor}
                     opacity="0.2"
                  />
               </View>
               <UserAccountControl />
               <ToolsBlock popoverAnchorOriginVertical="top" />
            </View>
         </View>
         <View
            width="100%"
            height={theme.tmpViewportHeight}
            display="block[a-c] flex[d-f]"
            paddingLeft={`
               ${theme.tmpViewportPaddingD}[d]
               ${theme.tmpViewportPaddingE}[e]
               ${theme.tmpViewportPaddingF}[f]
            `}
            scroll="on">
            <View
               display="none[a-c] block[d-f]"
               paddingTop="20px"
               paddingRight="20px"
               width="210px[d] 250px[e-f]">
               <NavVertical
                  buttonActiveTextColor={theme.tmpAsideButtonActiveTextColor}
                  buttonActiveBackgroundColor={theme.tmpAsideButtonActiveBackgroundColor}
                  buttonLineColor={theme.tmpAsideLineColor}
                  buttonTextColor={theme.tmpAsideButtonTextColor}
               />
            </View>
            <View
               marginBottom="15px[d-f]"
               width="100%[a-c] calc(100% - 210px)[d] calc(100% - 250px)[e-f]">
               {children}
            </View>
         </View>
      </>
   )
}

BoxLayout.propTypes = {
   children: PropTypes.node.isRequired
}

export default BoxLayout
